[
  {
    "id": "SWW-E7-L205-001",
    "module": "SpellingWW",
    "difficulty": 205,
    "difficultyTier": 11,
    "levelCode": "E7",
    "group": 7,
    "question": "Hij ... zijn jas aan. (pakken)",
    "options": ["pakt", "pak", "pakte", "gepakt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tegenwoordige_tijd",
    "subSkill": "tt_hij",
    "familyId": "SWW-TT-HIJ-PAKKEN",
    "conceptId": "tt_hij_stam_plus_t",
    "variantIndex": 1,
    "explanation": "Onderwerp is 'hij'. In de tegenwoordige tijd is dat stam + t. Stam van 'pakken' is 'pak'. Pak + t = pakt.",
    "distractorExplanations": {
      "1": "Dit is de ik-vorm: ik pak. Bij 'hij' hoort pakt.",
      "2": "Dit is verleden tijd. De zin gaat over nu.",
      "3": "Dit is het voltooid deelwoord. Dat gebruik je met 'heeft': hij heeft gepakt."
    }
  },
  {
    "id": "SWW-E7-L205-002",
    "module": "SpellingWW",
    "difficulty": 205,
    "difficultyTier": 11,
    "levelCode": "E7",
    "group": 7,
    "question": "Wij ... gisteren een film. (kijken)",
    "options": ["keken", "kijkten", "kijken", "gekeken"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verleden_tijd",
    "subSkill": "vt_sterk",
    "familyId": "SWW-VT-STERK-KIJKEN",
    "conceptId": "vt_sterk_meervoud",
    "variantIndex": 1,
    "explanation": "Door 'gisteren' kies je verleden tijd. 'Kijken' is sterk. Meervoud verleden tijd is: keken.",
    "distractorExplanations": {
      "1": "Dit lijkt op een zwak werkwoord, maar 'kijken' is sterk: keken.",
      "2": "Dit is tegenwoordige tijd. 'Gisteren' vraagt verleden tijd.",
      "3": "Dit is het voltooid deelwoord. Dat gebruik je met 'hebben': wij hebben gekeken."
    }
  },
  {
    "id": "SWW-E7-L205-003",
    "module": "SpellingWW",
    "difficulty": 205,
    "difficultyTier": 11,
    "levelCode": "E7",
    "group": 7,
    "question": "De brief is ... (schrijven).",
    "options": ["geschreven", "geschrijfd", "schreef", "schrijft"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_sterk",
    "familyId": "SWW-VD-STERK-SCHRIJVEN",
    "conceptId": "vd_sterk_basis",
    "variantIndex": 1,
    "explanation": "Na 'is' gebruik je een voltooid deelwoord. 'Schrijven' is sterk. Het voltooid deelwoord is: geschreven.",
    "distractorExplanations": {
      "1": "Sterke werkwoorden krijgen geen -d of -t volgens 't kofschip. Dit is geen juiste vorm.",
      "2": "Dit is verleden tijd. Na 'is' hoort het voltooid deelwoord.",
      "3": "Dit is tegenwoordige tijd. Na 'is' hoort een voltooid deelwoord."
    }
  },
  {
    "id": "SWW-E7-L205-004",
    "module": "SpellingWW",
    "difficulty": 205,
    "difficultyTier": 11,
    "levelCode": "E7",
    "group": 7,
    "question": "De ... fiets staat buiten. (repareren)",
    "options": ["gerepareerde", "gerepareerd", "repareerde", "gereparerde"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "bijvoeglijk_deelwoord",
    "subSkill": "bn_vd",
    "familyId": "SWW-BNVD-REPAREREN",
    "conceptId": "bnvd_dewoord_e",
    "variantIndex": 1,
    "explanation": "Je beschrijft de fiets. Dat is bijvoeglijk gebruikt voltooid deelwoord. 'Gerepareerd' krijgt bij 'de fiets' een -e: gerepareerde.",
    "distractorExplanations": {
      "1": "Dit mist de -e. Bij 'de fiets' hoort: gerepareerde.",
      "2": "Dit is verleden tijd. De zin vraagt om een beschrijving.",
      "3": "Hier staat een extra r. De juiste vorm is gerepareerde."
    }
  }
]
